module.exports = __webpack_public_path__ + "img/doctor_primary.13381053.svg";